import { Suspense } from "react";
import { Outlet } from "react-router-dom";
import { Loader2 } from "lucide-react";

import { ClientShell } from "./ClientShell";

/**
 * Layout route for the authenticated client portal.
 *
 * Renders the shared <ClientShell/> ONCE and swaps page content via <Outlet/>,
 * so the sidebar + top bar stay mounted (no re-animation / auth re-check on
 * navigation). Content is full-width with admin-matched padding — each page
 * sets its own inner width where a form benefits from it.
 *
 * The inner <Suspense> catches lazy page-chunk loads HERE (content area only)
 * instead of letting them bubble to the app-level boundary — otherwise the
 * first visit to each page blanked the whole shell with a full-screen spinner,
 * which read as a hard router refresh.
 */
export const ClientLayout = () => (
  <ClientShell>
    <Suspense
      fallback={
        <div className="flex min-h-[40vh] flex-1 items-center justify-center">
          <Loader2 className="h-6 w-6 animate-spin text-muted-foreground" />
        </div>
      }
    >
      <Outlet />
    </Suspense>
  </ClientShell>
);

export default ClientLayout;
